import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DressfitPanelComponent, injectDressfitModule } from '@pixacare/dressfit-angular';
import { type FormAnswer, type ModuleConfig, type ModuleResult } from '@pixacare/forms';
import { FormBridge } from '@pixacare/forms-angular';
import { map } from 'rxjs';
import { DressfitBannerComponent } from '../dressfit-banner/dressfit-banner.component';

// Tailwind's `max-md`, word for word: pxc-form stacks its side column under the questions at the same breakpoint.
const MOBILE_MEDIA_QUERY = 'not all and (min-width: 768px)';

@Component({
  selector: 'pxc-dressfit-interactive-module',
  templateUrl: './dressfit-interactive-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DressfitBannerComponent, DressfitPanelComponent],
  host: { class: 'flex min-h-0 flex-1 flex-col' },
})
export class DressfitInteractiveModuleComponent {
  readonly config = input.required<ModuleConfig>();
  readonly formAnswer = input.required<FormAnswer>();
  readonly onEmit = input.required<(result: ModuleResult) => void>();

  private readonly formBridge = inject(FormBridge);
  // The panel needs a full column: a phone screen gets the banner instead, which opens it on demand.
  protected readonly isMobile = toSignal(
    inject(BreakpointObserver)
      .observe(MOBILE_MEDIA_QUERY)
      .pipe(map((state) => state.matches)),
    { requireSync: true },
  );

  protected readonly session = injectDressfitModule({
    config: this.config,
    formAnswer: this.formAnswer,
    onEmit: this.onEmit,
    questions: this.formBridge.questions,
  });
}
